/**
* DevExpress Dashboard (_widgets-viewer-base.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { Disposable } from '@devexpress/analytics-core/analytics-utils';
import { Options } from 'devextreme/core/options';
export class WidgetsViewerBase extends Disposable {
    element() {
        return this._element;
    }
    option(...args) {
        return this._optionManager.option(...args);
    }
    get _option() {
        return this.option();
    }
    constructor(element, options) {
        super();
        this._initalized = false;
        this._element = typeof element === 'string' ? document.querySelector(element) : element;
        this.addDisposable(() => this._element = null);
        this.addDisposable(this._optionManager = new Options(this._getDefaultOptions(), this._getDefaultOptions(), {}, {}));
        this._optionManager.onChanging(() => { });
        this._optionManager.onChanged(() => { });
        this._optionManager.onStartChange(() => { });
        this._optionManager.onEndChange(() => {
            if (this._initalized) {
                this._update();
            }
        });
        this._optionManager.option(options);
        this._init();
        this._initalized = true;
    }
}
